import {  FC, useEffect, useRef, useState } from "react"
import { TieredMenu } from 'primereact/tieredmenu';
import { Button } from "primereact/button";
import './scenarioselector.css'

import { useHistory } from "react-router-dom";

export const ScenarioSelector:FC<any> = (props):JSX.Element => {

    const { allScenarios, flagChangeScenario, title, base, scenarioBase , color, disabled, loadingScenarioComparision, simulation, operative } = props

    const menu:any = useRef(null);

    const history:any = useHistory()

    const [open, setOpen] = useState<boolean>(false)

    const [items, setItems] = useState<any[]>([])

    const handleOpenCloseMenu = (e:any) => {
        menu.current.toggle(e)
        setOpen(!open)
    }

    const handleSelectScenario = (e:any) => {
        if(base) {
            
            history.push(`/scenario_view/${parseInt(e.item.id)}/${parseInt(e.item.id)}`)
        } else {
            
            history.push(`/scenario_view/${parseInt(scenarioBase.id_scenario)}/${parseInt(e.item.id)}`)
            //setScenarioToCompare(parseInt(e.item.id))
        }
        
    }

    const handleSelectOperativeScenario = (e:any) => {
        history.push(`/operative_scenario/${parseInt(e.item.id)}`)  
    }

    const handleSelectSimulation = (e:any) => {
        if(base) {
            
            history.push(`/scenario_plan/${parseInt(e.item.id)}/${parseInt(e.item.id)}`)
        } else {
            
            history.push(`/scenario_plan/${parseInt(scenarioBase.id_scenario)}/${parseInt(e.item.id)}`)
            //setScenarioToCompare(parseInt(e.item.id))
        }
        
    }

    
    useEffect(() => {
        let dropwdown :any[] = []
        allScenarios?.map((d:any,index:number) => {
            if(d.id_planner === 1) {
                if(!operative) {
                    dropwdown.push({
                        label: d.name_planner,
                        items: []
                    })
                    const { plants } = d
                    plants.sort((a:any,b:any) => a.id_plant - b.id_plant).map((p:any) => dropwdown[index]?.items.push({
                        label: p?.name_plant,
                        items: p?.scenarios.filter((esc:any) => !esc.borrado).sort((a:any,b:any) => a.id_scenario - b.id_scenario).map((s:any) => (
                            {
                                label: s?.name_scenario,
                                icon: 'pi pi-globe',
                                id: s?.id_scenario,
                                disabled: (!base && scenarioBase.id_plant !== p?.id_plant) || (simulation && !s.simulado),
                                command: simulation? (e:any) => handleSelectSimulation(e) : (e:any) => handleSelectScenario(e)
                            }
                            )
                            )
                        })
                        )
                    }
                } else {
                    if(operative) {
                        dropwdown.push({
                            label: d.name_planner,
                            items: []
                        })
                        const { plants } = d
                        plants.sort((a:any,b:any) => a.id_plant - b.id_plant).map((p:any) => dropwdown[0]?.items.push({
                            label: p?.name_plant,
                            items: p?.scenarios.sort((a:any,b:any) => a.id_scenario - b.id_scenario).map((s:any) => (
                                {
                                    label: s?.name_scenario,
                                    icon: 'pi pi-globe',
                                    id: s?.id_scenario,
                                    command: (e:any) => handleSelectOperativeScenario(e)
                                }
                                )
                                )
                            })
                            )
                        }
                    }
                })
                setItems(dropwdown)
    },[flagChangeScenario,scenarioBase,allScenarios])



    
    return (
        <div className="card flex justify-content-center">
            <TieredMenu className="scenario__selector-menu" model={items} popup ref={menu} breakpoint="767px" onClick={(e:any) => console.log(e)} />
            <Button disabled={disabled} className="settings-button" style={{borderColor:color,fontSize:'0.75rem', minWidth:215, backgroundColor:color}} label={operative? 'Operativo' : 'Estratégico'} icon= {!open? 'pi pi-arrow-circle-down' : 'pi pi-arrow-circle-up'} onClick={handleOpenCloseMenu} iconPos="right">
            
                    <span style={{marginRight:15}}>{loadingScenarioComparision ? "" : title}</span>
            
            
            </Button>
        </div>
    )
}